import { lazy } from '@/service/lazy'

export default [{
  name: 'Lojas',
  path: 'unidades',
  id: 'unidades',
  icon: 'fa fa-building-o',
  component: lazy('app/default/gerenciador/unidade/index'),
  meta: { requireAuth: true, rules: ['gerenciar_unidade'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/unidade.js